export const DMS_MODULE = 'Servis';
export const NAME = 'TechnicianClocking';
export const API_NAME = 'TechnicianClocking';
export const EXPORT_FILE_NAME='TechnicianClocking.xlsx';
export const CRUMB_LABEL_KEY = 'TechnicianClocking';
